import { computed, inject, Injectable, signal } from '@angular/core';
import { CacheLoaderService } from './cache-loader.service';
import { Lender } from '@/models/bank-models.model';
import { AppAuthService } from '../app/auth.service';
import { OfficesService } from './franchises.service';
import { BinderService } from './binder.service';
import { FIDService } from '../app/fid.service';

@Injectable({
  providedIn: 'root'
})
export class LendersService {
  lenders = signal<Lender[]>([]);

  binderService = inject(BinderService);

  selectedLender = signal<Lender | null>(null);

  filteredLenders = computed(() => this.lenders().filter(lender => lender.LenderContacts && lender.LenderContacts.some(contact => contact.FID === this.fidService.determineBankFid(this.binderService.currentBinder().Franchises_Binders_SelectedFIDToFranchises.Bank_FID, this.binderService.currentBinder().SelectedFID))));

  constructor(private cacheLoader: CacheLoaderService<Lender>, private fidService: FIDService) {}

  setLenders(lenders: Lender[]) {
    this.lenders.set(lenders);
  }

  loadLenders(): void {
    this.cacheLoader.loadData('lenders', (lenders) => {
        // console.log('Lenders loaded:', lenders);
        this.setLenders(lenders);
    }, 'lendersCacheKey');
}
}
